var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"roll-history-element",class:{
    'element-high': _vm.rollGetOutcome >= 20,
    'element-mid': _vm.rollGetOutcome < 20 && _vm.rollGetOutcome >= 5,
    'element-low': _vm.rollGetOutcome < 5 && _vm.rollGetOutcome >= 2
},on:{"click":_vm.rollInfoButton}},[_c('div',{staticClass:"element-inner"},[_c('span',[_vm._v(_vm._s(_vm.rollGetOutcome)+"x")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }